module.exports = __webpack_public_path__ + "img/enter-details.c57ca1e1.svg";